import * as React from 'react';
import { createRoot } from 'react-dom/client';
import { Card } from "../../Interfaces/general.interface";
import './CardsBlock.min.css';
import Helper from "../../Interfaces/Helper";
import { Component } from 'react';

interface Props {
    currentPageId: string;
    componentId: string;
    query: string;
}
const API_URL = "/api/Cards";
class CardsBlock extends Component {
    state:
        {
            id: string;
            query: string;
            error: boolean;
            items: Card[];
            currentPageId: number;
            isLoaded: boolean;
        };
    props: Props;
    constructor(props) {

        super(props);

        this.state = {
            ...props,
            error: false,
            isLoaded: false,
            items: []
        };
    }

    componentDidMount() {
        Helper.fetchData({ API_URL, queryId: this.state.query, pageId: this.state.currentPageId })
            .then(
                (result) => {
                    this.setState({
                        isLoaded: true,
                        items: result
                    });

                },
                (error) => {
                    this.setState({
                        isLoaded: true,
                        error: true
                    });
                }
            )
    }

    render() {
        const { error, isLoaded, items } = this.state;

        if (isLoaded && !error) {
            return (
                <div className="container">
                    <div id={"cards-block-" + this.props.componentId}
                    className="row justify-content-center section posts-holder pb-3 pt-3 mb-0">
                    {items.map((card, idx) =>
                        this.renderItem(card, idx)
                    )}
                    </div>
                </div>
            )
        }
        return (null);
    }


    renderItem = (card, index) => {
        var cardAbstract = card.cardAbstract;
        var cardImage = card.cardImage;
        var cardDuotoneBaseColor = card.cardDuotoneBaseColor;
        var cardBaseColor = cardDuotoneBaseColor + "4D";
        var cardBaseHoverColor = cardDuotoneBaseColor + "99";
        var cardBaseColorBack = cardDuotoneBaseColor + "00";
        var cardBaseColorBack2 = cardDuotoneBaseColor + "22";

        var postClassSelector = "post_" + cardDuotoneBaseColor;
        var cardLink = card.cardLink;
        var linkTitle = cardLink != null ? cardLink.title : "";
        var linkUrl = cardLink != null ? cardLink.url : "#";
        var linkTarget = cardLink != null ? cardLink.target : null;
        var animationDelay = 0.5 + (index * 0.2); // Start at 0.5s, stagger by 200ms per card

        return <div className="col-12 col-md-5 col-lg-4 anim" key={`${this.props.componentId}-${index}`} style={{ animationDelay: `${animationDelay}s` }}>
            <article className={`post post_${card.cardDuotoneBaseColor} mt-4 mb-4`}>
                <a href={linkUrl} target={linkTarget} title={linkTitle}>
                    <figure>
                        {cardImage &&
                            <img src={cardImage} />
                        }
                        <figcaption className="visually-hidden">{linkTitle}</figcaption>
                    </figure>
                    <p className="text-block">
                        <span className="h2" title={linkTitle}><span>{linkTitle}</span></span>
                        <span className="d-block">{cardAbstract}</span>
                    </p>
                </a>
            </article>
            <style>
                {`
                    .${postClassSelector} figure {
                        background-color: #${cardBaseColor}
                    }  
                    .${postClassSelector}:hover figure {
                        background-color: #${cardBaseHoverColor}
                    }
                    .${postClassSelector} .text-block {
                        background: linear-gradient(90deg, #${cardBaseColorBack} 18.27%, #${cardBaseColorBack2} 51.44%) !important;
                    }
                    @media (max-width: 1023px) {
                        .posts-holder > div:nth-child(2n) .${postClassSelector} .text-block {
                        background: linear-gradient(-90deg, #${cardBaseColorBack} 18.27%, #${cardBaseColorBack2} 51.44%) !important;
                        }
                    }
                    .anim {
                        opacity: 0;
                        animation: fadeInUp 0.9s cubic-bezier(0.17, 0.55, 0.55, 1) forwards;

                    }
                    @keyframes fadeInUp {
                        from {
                            opacity: 0;
                            transform: translateY(200px);
                        }
                        to {
                            opacity: 1;
                            transform: translateY(0);
                        }
                    }
                `}
            </style>
        </div>;
    }
}

var elements = document.querySelectorAll('[id^="CardsBlock-"]');
for (var i = 0; i < elements.length; i++) {
    var rootElement = document.getElementById(elements[i].id);
    var root = createRoot(rootElement);

    root.render(
        <CardsBlock
            currentPageId={rootElement.getAttribute('component-currentPageId')}
            componentId={rootElement.getAttribute('component-id')}
            query={rootElement.getAttribute('component-query')}
        />)
}